"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildQueryString = function (config) {
    var params = [];
    for (var key in config) {
        if (config[key]) {
            params.push(key + "=" + config[key]);
        }
    }
    return params.join('&');
};
//# sourceMappingURL=widget.utils.js.map